'use client';
import React from 'react';

function Intro2() {
  function openAccordion(event) {
    document.querySelectorAll('.accordion-info').forEach((element) => {
      element.classList.remove('active');
      element.style.maxHeight = 0;
      element.parentElement.classList.remove('active');
    });
    event.currentTarget.parentElement.classList.add('active');
    event.currentTarget.nextElementSibling.style.maxHeight = '300px';
    event.currentTarget.nextElementSibling.classList.add('active');
  }

  return (
    <section className="intro-accord">
      <div className="container ontop">
        <div className="row xlg-marg">
          <div className="col-lg-6">
            <div className="img md-mb50">
              <img src="/assets/imgs/intro/ui-ux-mockup.png" alt="UI/UX" style={{ borderRadius: '12px' }} />
            </div>
          </div>
          <div className="col-lg-6 valign">
            <div>
              <div className="sec-head mb-50">
                <h6 className="sub-title main-color mb-15">Neden bizi seçmelisiniz?</h6>
                <h3>
                  Dijital pazarlama sürecimizin <br /> arkasındaki yaratıcı yaklaşım.
                </h3>
              </div>
              <div className="accordion bord">
                <div className="item active wow fadeInUp" data-wow-delay=".1s">
                  <div onClick={openAccordion} className="title">
                    <h6>Modern Teknoloji ile İçerik Tasarımı</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      En güncel tasarım trendleri ve teknolojileri kullanarak
                      markanıza özel, etkileyici dijital içerikler üretiyoruz.
                    </p>
                  </div>
                </div>

                <div className="item wow fadeInUp" data-wow-delay=".3s">
                  <div onClick={openAccordion} className="title">
                    <h6>Yetenekli, Profesyonel ve Uzman Ekip</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      Alanında uzman tasarımcılar, geliştiriciler ve pazarlama
                      uzmanlarından oluşan deneyimli ekibimizle projelerinizi
                      güvenle teslim ediyoruz.
                    </p>
                  </div>
                </div>

                <div className="item wow fadeInUp" data-wow-delay=".5s">
                  <div onClick={openAccordion} className="title">
                    <h6>Marka Oluşturma ve Aktivasyon</h6>
                    <span className="ico ti-plus"></span>
                  </div>
                  <div className="accordion-info">
                    <p>
                      Markanızı sıfırdan inşa ediyor, dijital kanallarda güçlü
                      bir varlık oluşturarak hedef kitlenizle bağ kurmanızı
                      sağlıyoruz.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro2;
